import glamorous from 'glamorous';
import Lead from '@marmalade/bling/lib/lead';

const B2BLead = glamorous(Lead)({ lineHeight: 'inherit' });

export default B2BLead;
